export default __webpack_public_path__ + "static/pinterest-163c868c89b9a5d28b0f3f819d36d675.png";